import { apiClient } from '../utils/api';

export async function getProcedures() {
    try {
        return await apiClient.GET(
            `api/procedures`
        );
    } catch (err) {}
}

export async function getProceduresByStaffId(staffId) {
    return await apiClient.GET(`api/procedures?staff_id=${staffId}`);
}

export async function getProcedureStaffByStaffId(staffId) {
    return await apiClient.GET(`api/procedure/staff?staff_id=${staffId}`);
}

export async function getProceduresStaffByProcedureIds(procedureIds) {
    try {
        return await apiClient.GET(
            `api/procedure/staff?in[procedure_id]=${procedureIds.join(',')}`
        );
    } catch (err) {}
}
